import { useRef, useState, useEffect } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import ChatInterface from "@/components/ChatInterface";
import Footer from "@/components/Footer";
import useChatBot from "@/hooks/useChatBot";

const HomePage = ({ isDarkMode, toggleDarkMode }) => {
  const chatRef = useRef(null);
  const [showChat, setShowChat] = useState(false);
  const { 
    messages, 
    isTyping, 
    userInput, 
    setUserInput, 
    handleSendMessage, 
    handleOptionClick, 
    resetChat,
    showSuggestions,
    getFollowUpSuggestions
  } = useChatBot();

  // Function to scroll to chat section and show it
  const scrollToChat = () => {
    setShowChat(true);
    
    // After showing chat, scroll to it
    setTimeout(() => {
      if (chatRef.current) {
        chatRef.current.scrollIntoView({ behavior: 'smooth' });
        setTimeout(() => {
          const inputEl = document.getElementById('userInput');
          if (inputEl) inputEl.focus();
        }, 500);
      }
    }, 100);
  };

  return (
    <>
      <Navbar 
        isDarkMode={isDarkMode} 
        toggleDarkMode={toggleDarkMode} 
        onSectionClick={handleOptionClick}
        scrollToChat={scrollToChat}
      />
      
      <main className="flex-grow">
        <Hero scrollToChat={scrollToChat} />
        
        {showChat && (
          <div ref={chatRef}>
            <ChatInterface 
              messages={messages}
              isTyping={isTyping}
              userInput={userInput}
              setUserInput={setUserInput}
              handleSendMessage={handleSendMessage}
              handleOptionClick={handleOptionClick}
              resetChat={resetChat}
              showSuggestions={showSuggestions}
              getFollowUpSuggestions={getFollowUpSuggestions}
            />
          </div>
        )}
      </main>
      
      <Footer />
    </>
  );
};

export default HomePage;
